import * as Yup from 'yup';

export const validation = Yup.object().shape({
  fullDate: Yup.date().nullable(),
  time: Yup.string(),
});
